import React, { FunctionComponent } from "react"
import { FormControl, OverlayTrigger, Table } from "react-bootstrap"
import ClientPortalEmployeeAccessLevelAreaTypes from "../Types/ClientPortalEmployeeAccessLevelAreaTypes"
import EALAService from "../Utils/EALAService"
import EALATableItemTitle from "./EALATableItemTitle/EALATableItemTitle"
import "./EALATable.css"

interface Props {
    manageParentState: Function
    ealas: ClientPortalEmployeeAccessLevelAreaTypes[]
    AccessLevelID: number
    editIsDirty: boolean
    fade: boolean
    isNaughty: boolean
}

const EALATable: FunctionComponent<Props> = (props) => {

    const { manageParentState, ealas, AccessLevelID, editIsDirty, fade, isNaughty } = props
    const { tableItems, lookupHashTableItem, getLocationDescriptions, checkForAddOrDropOrSame, checkForDropEala, EALAServiceTooltip } = EALAService

    const isChecked = (eala: ClientPortalEmployeeAccessLevelAreaTypes, key: string) => {
        //@ts-ignore
        return eala[key]
    }

    // console.log("EALATable ealas", ealas)

    return (
        <div className={`EALATable ${fade ? "EALATableFaded" : "EALATableNotFaded"}`}>
            {ealas.length > 0 && <Table id="eala-table" /*striped bordered*/>
                <tbody>
                    {ealas.map((eala, i) => {
                        const titles = getLocationDescriptions(eala)
                        const dropEala = checkForDropEala(eala)
                        return (
                            <tr
                                className={`EALATableTRDropEALA${dropEala}`}
                                key={i}
                            >
                                {tableItems.map((tdItem, j) => {
                                    const itemChecked = isChecked(eala, tdItem.key)
                                    const addOrDropOrSame = checkForAddOrDropOrSame(eala, tdItem.key)
                                    //console.log("addOrDrop", addOrDrop)
                                    return (
                                        <td style={{ width: tdItem.width ? tdItem.width : "unset" }} key={j}>
                                            <div className="EALATableTD">
                                                {tdItem.lookupByID &&
                                                    <div className="EALATableTDTitle">
                                                        <EALATableItemTitle
                                                            AccessLevelID={AccessLevelID}
                                                            IsDefault={eala.IsDefault}
                                                            StateName={titles.StateName}
                                                            ProfitCenterLongDesc={titles.ProfitCenterLongDesc}
                                                            ServiceAreaLongDesc={titles.ServiceAreaLongDesc}
                                                            manageParentState={manageParentState}
                                                            isNaughty={isNaughty}
                                                            eala={eala}
                                                        />
                                                        {(eala.IsDefault > 0 && !isNaughty) && <div className={`EditDefaultAreaWrapper ${editIsDirty ? "EditDefaultAreaWrapperDisabled" : "EditDefaultAreaWrapperEnabled"}`}>
                                                            <OverlayTrigger placement="left" overlay={EALAServiceTooltip(`${editIsDirty ? "Save or revert your changes before editing the default service area" : "Edit default service area"}`)}>
                                                                <span onClick={() => manageParentState([{ key: "editDefaultArea", value: true }])} className="material-icons">edit</span>
                                                            </OverlayTrigger>
                                                        </div>}
                                                        {(!eala.IsDefault && AccessLevelID < 40) &&
                                                            <OverlayTrigger placement="left" overlay={EALAServiceTooltip(`${eala.ServiceAreaID ? "Edit the added service area" : "Add a service area"}`)}>
                                                                <div className="EALATableItemTitleAddServiceArea">
                                                                    <span
                                                                        id={eala.ServiceAreaID ? "f13f4c8668884a84ada05c809dff0d37" : "cdf23f179f3e450c9d64c367ab84be9f"}
                                                                        className="material-icons"
                                                                        onClick={() => {
                                                                            manageParentState([{ key: "ealaToAddServiceAreaTo", value: eala }])
                                                                        }}
                                                                    >{`${eala.ServiceAreaID ? "edit" : "add"}`}</span>
                                                                </div>
                                                            </OverlayTrigger>}
                                                    </div>
                                                }
                                                {!tdItem.lookupByID && tdItem.checkbox &&
                                                    <div
                                                        id={`eala-table-td-checkbox-${i}-${j}`}
                                                        className={`EALATableTDCheckbox EALATableTDCheckbox${addOrDropOrSame} EALATableTDCheckboxDropEALA${dropEala}`}
                                                        onClick={() => {
                                                            if (!dropEala && !isNaughty) {
                                                                let newEalas = [...ealas]
                                                                //@ts-ignore
                                                                newEalas[i][tdItem.key] = !itemChecked
                                                                manageParentState([{ key: "ealas", value: newEalas }])
                                                            }
                                                        }}
                                                    >
                                                        <div className="EALATableTDCheckboxLeft">
                                                            <FormControl
                                                                checked={itemChecked}
                                                                onChange={() => null}
                                                                type="checkbox"
                                                                disabled={dropEala || isNaughty}
                                                            />
                                                        </div>
                                                        <div className="EALATableTDCheckboxRight">
                                                            <p>{tdItem.title}</p>
                                                        </div>
                                                    </div>}
                                                {((j === tableItems.length - 1) && (eala.AccessLevelID === 20 || eala.AccessLevelID === 30)) &&
                                                    <OverlayTrigger placement="left" overlay={EALAServiceTooltip("View hierarchy tree")}>
                                                        <div className="EALATableTDTitleTreeLauncher">
                                                            <span onClick={() => {
                                                                const AccessLevelID = eala.AccessLevelID
                                                                const key = AccessLevelID === 20 ? "treeStateID" : "treeProfitCenterID"
                                                                const id = (AccessLevelID === 20 || AccessLevelID === 30) ? (AccessLevelID === 20 ? eala.StateID : eala.ProfitCenterID) : -1
                                                                if (id > -1) {
                                                                    manageParentState([{ key: key, value: id }])
                                                                }
                                                            }}
                                                                className="material-icons-outlined">account_tree
                                                            </span>
                                                        </div>
                                                    </OverlayTrigger>}
                                            </div>
                                        </td>
                                    )
                                }
                                )}
                            </tr>
                        )
                    }
                    )}
                </tbody>
            </Table>}
            {ealas.length === 0 && <div className="EALATableNoEALAS">
                <p className="EALATableNoEALASEmoji">{`(·.·)`}</p>
                <p className="EALATableNoEALASText">{`No access here...`}</p>
            </div>}
        </div>
    )
}

export default EALATable